import { useEffect, useState } from 'react'

export interface FeaturedEventProps {
	featuredEvent: EventProps
}

interface EventProps {
	id: number
	name: string
	url: string
}

export const FeaturedEvent = ({ featuredEvent }: FeaturedEventProps) => {
	const [showNotification, setShowNotification] = useState(false)

	useEffect(() => {
		const alreadyVisited = sessionStorage.getItem('visited')
		if (!alreadyVisited) {
			setShowNotification(true)
		}
	}, [])

	const handleClose = () => {
		setShowNotification(false)
		sessionStorage.setItem('visited', 'true')
	}

	return (
		showNotification && featuredEvent?.url && featuredEvent?.name && (
			<div className="bg-[#FCF38E] flex justify-between px-4 lg:px-8 py-2 lg:py-3 gap-4">
				<a href={featuredEvent?.url} onClick={() => sessionStorage.setItem('visited', 'true')} className="w-full text-body-xs md:text-body-sm font-medium flex items-center gap-2">
					<p>{featuredEvent?.name}</p>
					<svg
						className="w-4 h-4 md:w-5 md:h-5"
						viewBox="0 0 20 20"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							fillRule="evenodd"
							clipRule="evenodd"
							d="M11.0768 3.57739C11.4022 3.25195 11.9298 3.25195 12.2553 3.57739L18.0886 9.41072C18.2449 9.567 18.3327 9.77897 18.3327 9.99998C18.3327 10.221 18.2449 10.433 18.0886 10.5892L12.2553 16.4226C11.9298 16.748 11.4022 16.748 11.0768 16.4226C10.7513 16.0971 10.7513 15.5695 11.0768 15.2441L15.4875 10.8333L2.49935 10.8333C2.03911 10.8333 1.66602 10.4602 1.66602 9.99998C1.66602 9.53974 2.03911 9.16665 2.49935 9.16665L15.4875 9.16665L11.0768 4.7559C10.7513 4.43047 10.7513 3.90283 11.0768 3.57739Z"
							fill="#272727"
						/>
					</svg>
				</a>
				<button onClick={handleClose}>
					<svg
						className="w-4 h-4 md:w-5 md:h-5"
						viewBox="0 0 20 20"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							fillRule="evenodd"
							clipRule="evenodd"
							d="M4.41009 4.41076C4.73553 4.08533 5.26317 4.08533 5.5886 4.41076L9.99935 8.82151L14.4101 4.41077C14.7355 4.08533 15.2632 4.08533 15.5886 4.41077C15.914 4.7362 15.914 5.26384 15.5886 5.58928L11.1779 10L15.5886 14.4108C15.914 14.7362 15.914 15.2638 15.5886 15.5893C15.2632 15.9147 14.7355 15.9147 14.4101 15.5893L9.99935 11.1785L5.5886 15.5893C5.26317 15.9147 4.73553 15.9147 4.41009 15.5893C4.08466 15.2638 4.08466 14.7362 4.41009 14.4108L8.82084 10L4.41009 5.58928C4.08466 5.26384 4.08466 4.7362 4.41009 4.41076Z"
							fill="#272727"
						/>
					</svg>
				</button>
			</div>
		)
	)
}

export default FeaturedEvent
